import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./Services.css";
import Loading from "../../Components/Loading/Loading";
import AccordionComponent from "../../Components/Accordion/AccordionComponent";

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isFetchedServices = useRef(false); // ✅ Prevents duplicate API call

  useEffect(() => {
    if (!isFetchedServices.current) {
      fetchServices();
      isFetchedServices.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}api/Services`
      );
      setServices(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  if (loading) return <Loading />;
  if (error) return <p>Error: {error}</p>;
  return (
    <div className="services-container">
      <div className="services-pagetitle">
        <h1 className="firstpart">WHAT DO WE</h1>
        <h1 className="secondpart">ACTUALLY</h1>
        <h1 className="thirdpart">DO?</h1>
      </div>

      <div className="servicesmain-image">
        <img src="/images/servicesimage.svg" alt="Services Faces" />
      </div>

      <div className="accordion-container">
        {services != null && services.length > 0 && (
          <AccordionComponent items={services} />
        )}
      </div>
    </div>
  );
}

export default Services;
